import { render } from "./TheCalendar.vue?vue&type=template&id=2d4a8da5&scoped=true"
import script from "./TheCalendar.vue?vue&type=script&lang=js"
export * from "./TheCalendar.vue?vue&type=script&lang=js"

import "./TheCalendar.vue?vue&type=style&index=0&id=2d4a8da5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d4a8da5"

export default script